// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ql-editor{min-height:300px}.focusing .el-icon-close-tip{display:none!important}", ""]);
// Exports
module.exports = exports;
